const loadRequests = () =>
  $.ajax({
    url: App.api.userAccount(),
    headers: { "Email-Hunter-Origin": "website_dashboard" },
    type: "GET",
    data: { format: "json", show_overage_requests: true },
    dataType: "json",
    success(result) {
      if (result.data.requests.searches.available > 0 || result.data.requests.verifications.available > 0) {
        const locale = i18n.locale
        const numberFormatter = new Intl.NumberFormat(locale, { notation: "compact" })

        if (result.data.requests.credits) {
          // Team is using single credits bucket
          const availableCredits =
            result.data.requests.credits.available > 99999
              ? numberFormatter.format(result.data.requests.credits.available)
              : App.numberWithCommas(result.data.requests.credits.available)
          const creditsPercentage = Math.min(
            (result.data.requests.credits.used / result.data.requests.credits.available) * 100,
            100,
          )
          const creditsOverQuota =
            result.data.requests.credits.over_quota > 0 ? result.data.requests.credits.over_quota : 0

          if (result.data.requests.credits.used > result.data.requests.credits.available) {
            // We make a special case here as it can happen that user used more
            // calls than what his plan offers (in case of a move to a Free plan,
            // for example)
            $(".current-credits-requests").html(
              `${App.numberWithCommas(result.data.requests.credits.used + creditsOverQuota)}`,
            )
          } else {
            $(".current-credits-requests").html(
              `${App.numberWithCommas(result.data.requests.credits.used + creditsOverQuota)} / ${availableCredits}`,
            )
          }

          // We take the min between both there as it can happen that user used
          // more calls than what his plan offers (in case of a move to a free
          // plan, for example)
          $(".used-credits-requests-level").removeClass("is-loading")
          $(".used-credits-requests-level").css("width", `${creditsPercentage}%`)

          if (
            result.data.requests.credits.hasOwnProperty("over_quota") &&
            result.data.requests.credits.over_quota > 0
          ) {
            const creditsOveragePercentage = Math.min(
              (creditsOverQuota * 100) / (result.data.requests.credits.used + creditsOverQuota),
            )
            const creditsQuotaPercentage = Math.min(100 - creditsOveragePercentage)

            $(".overage-credits-requests-level").css("width", `${creditsOveragePercentage}%`)
            $(".used-credits-requests-level").css("width", `${creditsQuotaPercentage}%`)
            $(".overage-credits-requests-level").removeClass("d-none")
            $(".used-credits-overage-requests")
              .html(`${App.numberWithCommas(creditsOverQuota)} ${i18n.t("js.over_quota")}`)
              .removeClass("d-none")
          } else {
            $(".overage-credits-requests-level").addClass("d-none")
            $(".used-credits-overage-requests").addClass("d-none")
          }
        } else {
          // Team is using multiple credits buckets

          // First, take care of the searches gauge
          const availableSearches =
            result.data.requests.searches.available > 99999
              ? numberFormatter.format(result.data.requests.searches.available)
              : App.numberWithCommas(result.data.requests.searches.available)
          const searchPercentage = Math.min(
            (result.data.requests.searches.used / result.data.requests.searches.available) * 100,
            100,
          )
          const searchOverQuota =
            result.data.requests.searches.over_quota > 0 ? result.data.requests.searches.over_quota : 0
          if (result.data.requests.searches.used > result.data.requests.searches.available) {
            // We make a special case here as it can happen that user used more
            // calls than what his plan offers (in case of a move to a Free plan,
            // for example)
            $(".current-search-requests").html(
              `${App.numberWithCommas(result.data.requests.searches.used + searchOverQuota)}`,
            )
          } else {
            $(".current-search-requests").html(
              `${App.numberWithCommas(result.data.requests.searches.used + searchOverQuota)} / ${availableSearches}`,
            )
          }

          // We take the min between both there as it can happen that user used
          // more calls than what his plan offers (in case of a move to a free
          // plan, for example)
          $(".used-search-requests-level").removeClass("is-loading")
          $(".used-search-requests-level").css("width", `${searchPercentage}%`)

          if (
            result.data.requests.searches.hasOwnProperty("over_quota") &&
            result.data.requests.searches.over_quota > 0
          ) {
            const searchOveragePercentage = Math.min(
              (searchOverQuota * 100) / (result.data.requests.searches.used + searchOverQuota),
            )
            const searchQuotaPercentage = Math.min(100 - searchOveragePercentage)

            $(".overage-search-requests-level").css("width", `${searchOveragePercentage}%`)
            $(".used-search-requests-level").css("width", `${searchQuotaPercentage}%`)
            $(".overage-search-requests-level").removeClass("d-none")
            $(".used-search-overage-requests")
              .html(`${App.numberWithCommas(searchOverQuota)} ${i18n.t("js.over_quota")}`)
              .removeClass("d-none")
          } else {
            $(".overage-search-requests-level").addClass("d-none")
            $(".used-search-overage-requests").addClass("d-none")
          }

          // And then, take care of the verifications gauge
          const availableVerifications =
            result.data.requests.verifications.available > 99999
              ? numberFormatter.format(result.data.requests.verifications.available)
              : App.numberWithCommas(result.data.requests.verifications.available)
          const verificationPercentage = Math.min(
            (result.data.requests.verifications.used / result.data.requests.verifications.available) * 100,
            100,
          )
          const verificationOverQuota =
            result.data.requests.verifications.over_quota > 0 ? result.data.requests.verifications.over_quota : 0
          if (result.data.requests.verifications.used > result.data.requests.verifications.available) {
            // We make a special case here as it can happen that user used more
            // calls than what his plan offers (in case of a move to a Free plan,
            // for example)
            $(".current-verify-requests").html(
              `${App.numberWithCommas(result.data.requests.verifications.used + verificationOverQuota)}`,
            )
          } else {
            $(".current-verify-requests").html(
              `${App.numberWithCommas(result.data.requests.verifications.used + verificationOverQuota)} / ${availableVerifications}`,
            )
          }

          // We take the min between both there as it can happen that user used
          // more calls than what his plan offers (in case of a move to a free
          // plan, for example)
          $(".used-verify-requests-level").removeClass("is-loading")
          $(".used-verify-requests-level").css("width", `${verificationPercentage}%`)

          if (
            result.data.requests.verifications.hasOwnProperty("over_quota") &&
            result.data.requests.verifications.over_quota > 0
          ) {
            const verificationOveragePercentage = Math.min(
              (verificationOverQuota * 100) / (result.data.requests.verifications.used + verificationOverQuota),
            )
            const verificationQuotaPercentage = Math.min(100 - verificationOveragePercentage)

            $(".overage-verify-requests-level").css("width", `${verificationOveragePercentage}%`)
            $(".used-verify-requests-level").css("width", `${verificationQuotaPercentage}%`)
            $(".overage-verify-requests-level").removeClass("d-none")
            $(".used-verify-overage-requests")
              .html(`${App.numberWithCommas(verificationOverQuota)} ${i18n.t("js.over_quota")}`)
              .removeClass("d-none")
          } else {
            $(".overage-verify-requests-level").addClass("d-none")
            $(".used-verify-overage-requests").addClass("d-none")
          }
        }
      } else {
        // the user account has been hard frozen, because of phone
        // validation or identity confirmation required. Anyways,
        // a click on the button will redirect the user to the
        // appropriate process.
        $(".app-main-nav-quota__info").html(
          `<div class="unlock-info"><a href="/dashboard" class="h-button h-button--primary">${i18n.t("js.back.navigation.click_here_to_unlock_account")}</a></div>`,
        )
        $(".app-main-nav-quota__upgrade").hide()
      }
    },
  })

// Fills the used requests bar and the requests counter
// when user opens the account dropdown
//
document.addEventListener("turbo:load", function () {
  $("#toggle-app-menu-user").on("click", function () {
    if (document.getElementById("app-menu-user").classList.contains("is-open")) {
      loadRequests()
    }
  })

  $(document).on("keyup", function (event) {
    if (event.which === 13 && $("#dropdown-account-link").is(":focus")) {
      return loadRequests()
    }
  })

  return $("#profile-pic-mobile-container").on("click", () => loadRequests())
})
